export const image = {
    'image/aces': {
        extensions: ['exr'],
        source: 'iana',
    },
    'image/avci': {
        extensions: ['avci'],
        source: 'iana',
    },
    'image/avcs': {
        extensions: ['avcs'],
        source: 'iana',
    },
    'image/avif': {
        extensions: ['avif'],
        source: 'iana',
    },
    'image/bmp': {
        extensions: ['bmp'],
        source: 'iana',
    },
    'image/cgm': {
        extensions: ['cgm'],
        source: 'iana',
    },
    'image/dicom-rle': {
        extensions: ['drle'],
        source: 'iana',
    },
    'image/emf': {
        extensions: ['emf'],
        source: 'iana',
    },
    'image/fits': {
        extensions: ['fits'],
        source: 'iana',
    },
    'image/g3fax': {
        extensions: ['g3'],
        source: 'iana',
    },
    'image/gif': {
        extensions: ['gif'],
        source: 'iana',
    },
    'image/heic': {
        extensions: ['heic'],
        source: 'iana',
    },
    'image/heic-sequence': {
        extensions: ['heics'],
        source: 'iana',
    },
    'image/heif': {
        extensions: ['heif'],
        source: 'iana',
    },
    'image/heif-sequence': {
        extensions: ['heifs'],
        source: 'iana',
    },
    'image/hej2k': {
        extensions: ['hej2'],
        source: 'iana',
    },
    'image/hsj2': {
        extensions: ['hsj2'],
        source: 'iana',
    },
    'image/ief': {
        extensions: ['ief'],
        source: 'iana',
    },
    'image/jls': {
        extensions: ['jls'],
        source: 'iana',
    },
    'image/jp2': {
        extensions: ['jp2', 'jpg2'],
        source: 'iana',
    },
    'image/jpeg': {
        extensions: ['jpeg', 'jpg', 'jpe', 'jfif', 'pjpeg', 'pjp'],
        source: 'iana',
    },
    'image/jph': {
        extensions: ['jph'],
        source: 'iana',
    },
    'image/jphc': {
        extensions: ['jhc'],
        source: 'iana',
    },
    'image/jpm': {
        extensions: ['jpm'],
        source: 'iana',
    },
    'image/jpx': {
        extensions: ['jpx', 'jpf'],
        source: 'iana',
    },
    'image/jxr': {
        extensions: ['jxr'],
        source: 'iana',
    },
    'image/jxra': {
        extensions: ['jxra'],
        source: 'iana',
    },
    'image/jxrs': {
        extensions: ['jxrs'],
        source: 'iana',
    },
    'image/jxs': {
        extensions: ['jxs'],
        source: 'iana',
    },
    'image/jxsc': {
        extensions: ['jxsc'],
        source: 'iana',
    },
    'image/jxsi': {
        extensions: ['jxsi'],
        source: 'iana',
    },
    'image/jxss': {
        extensions: ['jxss'],
        source: 'iana',
    },
    'image/ktx': {
        extensions: ['ktx'],
        source: 'iana',
    },
    'image/ktx2': {
        extensions: ['ktx2'],
        source: 'iana',
    },
    'image/png': {
        extensions: ['png'],
        source: 'iana',
    },
    'image/prs.btif': {
        extensions: ['btif'],
        source: 'iana',
    },
    'image/prs.pti': {
        extensions: ['pti'],
        source: 'iana',
    },
    'image/sgi': {
        extensions: ['sgi'],
        source: 'apache',
    },
    'image/svg+xml': {
        extensions: ['svg', 'svgz'],
        source: 'iana',
    },
    'image/t38': {
        extensions: ['t38'],
        source: 'iana',
    },
    'image/tiff': {
        extensions: ['tif', 'tiff'],
        source: 'iana',
    },
    'image/tiff-fx': {
        extensions: ['tfx'],
        source: 'iana',
    },
    'image/vnd.adobe.photoshop': {
        extensions: ['psd'],
        source: 'iana',
    },
    'image/vnd.airzip.accelerator.azv': {
        extensions: ['azv'],
        source: 'iana',
    },
    'image/vnd.dece.graphic': {
        extensions: ['uvi', 'uvvi', 'uvg', 'uvvg'],
        source: 'iana',
    },
    'image/vnd.djvu': {
        extensions: ['djvu', 'djv'],
        source: 'iana',
    },
    'image/vnd.dvb.subtitle': {
        extensions: ['sub'],
        source: 'iana',
    },
    'image/vnd.dwg': {
        extensions: ['dwg'],
        source: 'iana',
    },
    'image/vnd.dxf': {
        extensions: ['dxf'],
        source: 'iana',
    },
    'image/vnd.fastbidsheet': {
        extensions: ['fbs'],
        source: 'iana',
    },
    'image/vnd.fpx': {
        extensions: ['fpx'],
        source: 'iana',
    },
    'image/vnd.fst': {
        extensions: ['fst'],
        source: 'iana',
    },
    'image/vnd.fujixerox.edmics-mmr': {
        extensions: ['mmr'],
        source: 'iana',
    },
    'image/vnd.fujixerox.edmics-rlc': {
        extensions: ['rlc'],
        source: 'iana',
    },
    'image/vnd.microsoft.icon': {
        extensions: ['ico'],
        source: 'iana',
    },
    'image/vnd.ms-modi': {
        extensions: ['mdi'],
        source: 'iana',
    },
    'image/vnd.ms-photo': {
        extensions: ['wdp'],
        source: 'apache',
    },
    'image/vnd.net-fpx': {
        extensions: ['npx'],
        source: 'iana',
    },
    'image/vnd.pco.b16': {
        extensions: ['b16'],
        source: 'iana',
    },
    'image/vnd.tencent.tap': {
        extensions: ['tap'],
        source: 'iana',
    },
    'image/vnd.valve.source.texture': {
        extensions: ['vtf'],
        source: 'iana',
    },
    'image/vnd.wap.wbmp': {
        extensions: ['wbmp'],
        source: 'iana',
    },
    'image/vnd.xiff': {
        extensions: ['xif'],
        source: 'iana',
    },
    'image/vnd.zbrush.pcx': {
        extensions: ['pcx'],
        source: 'iana',
    },
    'image/webp': {
        extensions: ['webp'],
        source: 'apache',
    },
    'image/wmf': {
        extensions: ['wmf'],
        source: 'iana',
    },
    'image/x-3ds': {
        extensions: ['3ds'],
        source: 'apache',
    },
    'image/x-cmu-raster': {
        extensions: ['ras'],
        source: 'apache',
    },
    'image/x-cmx': {
        extensions: ['cmx'],
        source: 'apache',
    },
    'image/x-freehand': {
        extensions: ['fh', 'fhc', 'fh4', 'fh5', 'fh7'],
        source: 'apache',
    },
    'image/x-icon': {
        extensions: ['ico'],
        source: 'apache',
    },
    'image/x-jng': {
        extensions: ['jng'],
        source: 'nginx',
    },
    'image/x-mrsid-image': {
        extensions: ['sid'],
        source: 'apache',
    },
    'image/x-ms-bmp': {
        extensions: ['bmp'],
        source: 'nginx',
    },
    'image/x-pcx': {
        extensions: ['pcx'],
        source: 'apache',
    },
    'image/x-pict': {
        extensions: ['pic', 'pct'],
        source: 'apache',
    },
    'image/x-portable-anymap': {
        extensions: ['pnm'],
        source: 'apache',
    },
    'image/x-portable-bitmap': {
        extensions: ['pbm'],
        source: 'apache',
    },
    'image/x-portable-graymap': {
        extensions: ['pgm'],
        source: 'apache',
    },
    'image/x-portable-pixmap': {
        extensions: ['ppm'],
        source: 'apache',
    },
    'image/x-rgb': {
        extensions: ['rgb'],
        source: 'apache',
    },
    'image/x-tga': {
        extensions: ['tga'],
        source: 'apache',
    },
    'image/x-xbitmap': {
        extensions: ['xbm'],
        source: 'apache',
    },
    'image/x-xpixmap': {
        extensions: ['xpm'],
        source: 'apache',
    },
    'image/x-xwindowdump': {
        extensions: ['xwd'],
        source: 'apache',
    },
} as const;
